import User from './../modules/user'
import mixpanel from 'mixpanel-browser'
import { config } from './../Config'
import OneTrust from '../modules/OneTrust'

class MixPanelService {
    userData = {
        email: '',
        firstname: '',
        lastname: '',
        Client: '',
        roles: []
    }
    userInfo = ''
    wasMixPanelInitialized = false

    constructor() {
        if (OneTrust.isOneTrustIsInitialized()) {
            this.initialize()
        } else {
            const interval = setInterval(() => {
                const isOneTrustIsInitialized = OneTrust.isOneTrustIsInitialized()
                if (isOneTrustIsInitialized) {
                    clearInterval(interval)
                    this.initialize()
                }
            }, 100)
        }
    }

    initialize() {
        mixpanel.init(config.mixpanelToken, { debug: config.debugMode })
        User.getUserPermissions().then(roles => this.bindUserPermissionModel(roles))
        User.getUser().then(response => this.bindUserModel(response))
        this.wasMixPanelInitialized = true
    }

    async track(eventType, properties) {
        if (OneTrust.arePerformanceCookiesAccepted()) {
            // We do this, as user could potentially accepted the cookies during the session
            if (!this.wasMixPanelInitialized) this.initialize()

            if (this.userData.email !== '') {
                this.callMixPanel(eventType, properties)
            } else {
                var userData = await new Promise((resolve) => {
                    const observerInterval = window.setInterval(() => {
                        if (this.userData.email !== '') {
                            window.clearInterval(observerInterval)
                            this.callMixPanel(eventType, properties)
                            resolve('Event type called')
                        }
                    }, 100)
                })
            }

            return userData
        }
    }

    async AddUserData() {
        if (OneTrust.arePerformanceCookiesAccepted()) {
            if (!this.wasMixPanelInitialized) this.initialize()

            if (this.userInfo !== '') {
                this.callMixPanelForUserData()
            } else {
                var userData = await new Promise((resolve) => {
                    const observerInterval = window.setInterval(() => {
                        if (this.userInfo !== '') {
                            window.clearInterval(observerInterval)
                            this.callMixPanelForUserData()
                            resolve('event type called')
                        }
                    }, 500)
                })
            }
            return userData
        }
    }

    callMixPanelForUserData() {
        mixpanel.identify(this.userInfo.sub)
        mixpanel.people.set({ 'Client Domain': this.userInfo.email.split('@')[1] })
        mixpanel.people.set({ 'domain': window.location.hostname })
        mixpanel.people.set({ 'Company': this.userInfo.Client })
        mixpanel.people.unset(['email', 'Email', 'name', 'Name'])
    }

    callMixPanel(eventType, properties) {
        var objToPass = {
            'Client': this.userData.Client,
            'Role': this.userData?.roles?.join(',') || ''
        }
        if (typeof properties != 'undefined' && properties) {
            for (var key of Object.keys(properties)) {
                this.addKeyValue(objToPass, key, properties[key])
            } 
        }
        mixpanel.track(eventType, objToPass)
    }

    addKeyValue(obj, key, data) {
        obj[key] = data
    }

    bindUserPermissionModel(roles) {
        if (roles?.length > 0) {
            this.userData.roles = [...new Set(roles)]
        }
    }

    bindUserModel(res) {
        this.userData = {
            ...this.userData,
            email: res.email,
            firstname: res.given_name,
            lastname: res.family_name,
            Client: res.Client
        }
        this.userInfo = res
    }
}

export default new MixPanelService()
